module.exports = __webpack_public_path__ + "assets/images/0b7fb6f959b3fc297c629db6c98b6502.png";